import logoImg from "../../assets/images/logo.png";
import logoWhiteImg from "../../assets/images/logo_white.png";
import { Link, NavLink } from "react-router-dom";
import { sideBarNavigation } from "../../utilities/Constants";
import { FaChevronDown } from "react-icons/fa";
import NestedSideButton from "./NestedSideButton";

function Sidebar({ isSidenavClosed, darkMode, handleLogout, sideBarRef }) {
  return (
    <div
      ref={sideBarRef}
      className={`${
        isSidenavClosed
          ? "-translate-x-full cxl:translate-x-0"
          : "translate-x-0"
      } w-[260px] xl:w-[280px] h-screen cxl:relative fixed top-0 left-0 z-[99] bg-[#1D2235] dark:bg-darkModeBg dark:text-darkWhite transition-all duration-300 shadow-lg cxl:shadow-none `}
    >
      {/* border-r-[6px] border-white dark:border-[#333] */}
      <div className="w-full flex flex-col items-center py-4 px-6 h-full">
        <div className="mt-5">
          <Link to="/" className="hidden cxl:block">
            <img
              src={"https://i.ibb.co/wLc0Ggh/Route-Planner-white-1.webp"}
              className="w-full h-full"
              alt=""
            />
          </Link>
        </div>
        <div className="w-full rounded-xl mt-[85px] cxl:mt-10">
          {/* border dark:border-gray-700 border-gray-300 border-dashed  */}
          <ul className="w-full px-0 py-2 space-y-2">
            {sideBarNavigation?.map((item, idx) =>
              item?.subUrl?.length ? (
                <NestedSideButton key={idx} index={idx} items={item} />
              ) : (
                <li key={idx} className="w-full">
                  {/* border-b dark:border-gray-700 border-gray-300 border-dashed last:border-b-0 */}
                  <NavLink
                    end
                    to={`/${item.url}`}
                    className="w-full py-3 hover:bg-secondary/20 dark:text-white dark:hover:bg-secondary/20 dark:opacity-80 text-sm cxl:text-base my-0 flex items-center gap-4 whitespace-nowrap rounded-lg px-4 font-medium text-gray-50 capitalize transition-colors flex-row duration-100 relative"
                  >
                    <span className="text-xl">{item.icon}</span>
                    <span>{item.title}</span>
                    {item.subUrl?.length > 0 && (
                      <span>
                        <FaChevronDown />{" "}
                      </span>
                    )}
                  </NavLink>
                </li>
              )
            )}
          </ul>
        </div>
        <div className="w-full mt-auto">
          <button
            onClick={handleLogout}
            title="Sign out"
            className="flex w-full dark:text-darkWhite dark:hover:bg-[#00ac9b1a] dark:border-gray-700 border-gray-300 border-dashed rounded-xl py-2.5 items-center justify-center capitalize text-gray-50 text-base gap-4 transition duration-150 font-medium hover:bg-[#00ac9b1a] hover:border-[#00ac9b69] dark:hover:border-secondary"
          >
            <span>Sign out</span>
            <span className="text-gray-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={18}
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M7.5 1v7h1V1h-1z" />
                <path
                  className="fill-secondary"
                  d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
